import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ChatService } from './services/chat.service';
import { filter } from 'rxjs/operators';
import { ChatSelected } from './models/chatSelected.model';
import { AuthenticationService } from './services/authentication.service';
import { TitleService } from './services/title.service';
import { environment } from 'src/environments/environment';




@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'X-Tract-Fusion';
  isLoggedIn = false;
  chatOpen: boolean = false;
  selectedReference: ChatSelected | null = null;
  isAdmin = false;
  privilegios;
  privilegioTodo;
  privilegioAdmin;

  constructor(public translate: TranslateService, private chatService: ChatService, private authService: AuthenticationService,
    private titleService: TitleService
  ) {
    translate.addLangs(['es', 'en']);
    translate.setDefaultLang('es');

    // Forzamos la carga del archivo en.json y es.json
    translate.getTranslation('en').subscribe();
    translate.getTranslation('es').subscribe();

    translate.setDefaultLang('es');

    document.title = environment.title;

    titleService.getTitle$().subscribe(newTitle => {
      document.title = newTitle;
    });

    // Añadimos el listener para detectar cambios de visibilidad
    document.addEventListener('visibilitychange', this.handleVisibilityChange);

    // Se suscribe al observable para recibir actualizaciones del estado de autenticación
    this.authService.isLoggedIn$.subscribe(status => {
      this.isLoggedIn = status;
    });

    this.authService.getTipoUsuario().subscribe(tipoU => {
      this.isAdmin = tipoU == "1";
    });
    
    var language = localStorage.getItem("language");
    
    if(language != null && language != undefined)
      translate.setDefaultLang(language);
    // Suscribirse a la referencia seleccionada
    this.chatService.selectedReference$.pipe(filter(ref => ref !== null)).subscribe(ref => {
      this.chatOpen = !this.chatOpen;
      this.selectedReference = ref;
    });
  }

  async ngOnInit(){
    this.privilegios = await this.authService.getPrivilegiosUsuario().toPromise();
    this.privilegioTodo = await (await this.authService.getPrivilegio("Todo").toPromise()).toString();
    this.privilegioAdmin = await (await this.authService.getPrivilegio("Admin").toPromise()).toString();
  }

  tienePrivilegioAdmin() {
    return (this.privilegios != null && this.privilegios != undefined && this.privilegios.includes(this.privilegioAdmin));
  }

   // Función manejadora para el cambio de visibilidad
   handleVisibilityChange = () => {
    this.titleService.hidden = document.hidden;
    this.titleService.actualizarTitulo(this.titleService.numeroNotificaciones);
  };

  cambiarEstadoChat(chatOpen) {
    this.chatOpen = chatOpen;
  }

  switchLang(lang: string) {
    this.translate.use(lang);
  }

  onRightClick() {
    return false;
  }

  onKeyDown(event) {
    if (event.keyCode === 123) { //Prevent F12
      return false;
    }
    else if (event.ctrlKey && event.shiftKey && event.keyCode == 73) { // Prevent Ctrl+Shift+I        
      return false;
    }
  }

}
